import { render } from "./SurveyQuestionTag.vue?vue&type=template&id=5035cdf0"
import script from "./SurveyQuestionTag.vue?vue&type=script&lang=ts"
export * from "./SurveyQuestionTag.vue?vue&type=script&lang=ts"
script.render = render

export default script